import { Component, OnInit, ApplicationRef } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, FormArray, AbstractControl, Validators } from '@angular/forms';
import { ItemType } from '../../models/item-type';
import { Router, ActivatedRoute } from '@angular/router';
import { ItemTypeService } from '../../services/item-type.service';
import { EditForm } from '../../../../base/controlers/edit-form';
import { ToastrService } from 'ngx-toastr';
import { Location } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { ScheduleType } from '../../models/schedule-type';
import { ScheduleService } from '../../services/schedule.service';
import { DateValidators } from '../../../../validators/date-validators';
import { AfterFormPopulated } from '../../../../interfaces/iedit-form';
import { Schedule } from '../../models/schedule';
import { MatTableDataSource } from '@angular/material';
import { BehaviorSubject } from 'rxjs';


@Component({
  selector: 'app-schedule-edit',
  templateUrl: './schedule-edit.component.html',
  styleUrls: ['./schedule-edit.component.css']
})
export class ScheduleEditComponent extends EditForm<ScheduleType> implements AfterFormPopulated {
  public validFrom = new FormControl(new Date());
  public validTill = new FormControl(new Date());
  public dataSource: MatTableDataSource<any>
  public schedulesColumns: string[] =  ['actions','fromTime','tillTime','monday','tuesday','wednesday','thursday','friday','saturday','sunday','holiday'];
  rows = this.fb.array([]);
  constructor(
    ns: ToastrService,          
    tr: TranslateService,
    r: Router,
    ds:ScheduleService,
    ar: ActivatedRoute,
    l:Location,
    private fb: FormBuilder,
    private appRef: ApplicationRef        
  ) {
    super(ns,tr,r,ds,ar,l,'/timeTracking/schedules');
   }

   ngOnInit() {
    this.form = new FormGroup({
      id: new FormControl(),
      code: new FormControl(),
      name: new FormControl(),
      validFrom: this.validFrom,
      validTill: this.validTill,
      schedules: this.rows      
    },
    DateValidators.dateLessThan('validFrom','validTill', { 'validTill': true })
    )    
    super.ngOnInit();
  }
  onAfterFormPopulated() {      
    if(this.currentData.schedules){
      this.dataSource = new MatTableDataSource(this.currentData.schedules);
      //this.form.controls['schedules'].setValue(this.currentData.schedules);
      this.currentData.schedules.forEach(item=>{        
        this.rows.push(this.initSchedule(item));
      })
    }
  }
  initSchedule(data?:Schedule): FormGroup{

    if(data){
      return this.fb.group({
        id: [data.id||'00000000-0000-0000-0000-000000000000'],
        scheduleTypeId:[data.scheduleTypeId],
        fromTime: [data.fromTime, Validators.required],
        tillTime: [data.tillTime, Validators.required],
        monday: [data.monday],
        tuesday: [data.tuesday],
        wednesday: [data.wednesday],
        thursday: [data.thursday],
        friday: [data.friday],
        saturday: [data.saturday],
        sunday: [data.sunday],
        holiday: [data.holiday]
             });
    }
    else{
      return this.fb.group({
        id: ['00000000-0000-0000-0000-000000000000'],
        fromTime: [null, Validators.required],
        tillTime: [null, Validators.required],
        monday: [null],
        tuesday: [null],
        wednesday: [null],
        thursday: [null],
        friday: [null],
        saturday: [null],
        sunday: [null],
        holiday: [null]
             });
    }
  }
  addScedule(){
    
    let row:Schedule = new Schedule();
      this.rows.push(this.initSchedule(row));
      const data = this.dataSource.data;
      data.push(row);  //add the new model object to the dataSource
      this.dataSource.data = data;
  }

  deleteSchedule(idx:number){
    if (idx > -1) {
      this.rows.removeAt(idx);
      console.log('deleteSchedule delete');  
      let data = this.dataSource.data;
      data.splice(idx,1);      
      this.dataSource.data = data;
      console.log('rows',this.rows.value);
    }     
  }
  updateView() {
    this.dataSource._updateChangeSubscription();    
  }  
  editScedule(schedule:Schedule){

  }
}
